import { lazy } from 'react';

// ----------------------------------------------------------------------

const PackagesListPage = lazy(() => import('../pages/PackagesList.page'));
const AddPackagePage = lazy(() => import('../components/packages/AddPackageForm'));
const EditPackagePage = lazy(() => import('../components/packages/EditPackageForm'));
// ----------------------------------------------------------------------

const PackagesListRoutes = [
    {
        path: '/packages',
        children: [
            { element: <PackagesListPage />, layout: 'default', isAuthReq: true, index: true },
            { path: '/packages/add', element: <AddPackagePage />, layout: 'default', isAuthReq: true },
            { path: '/packages/edit/:id', element: <EditPackagePage />, layout: 'default', isAuthReq: true },
        ],
    },
];

export { PackagesListRoutes };
